import styled from 'styled-components';
import { Link } from 'react-router-dom';
import {Separator} from '@fluentui/react';
import { Button } from '@/components/buttons/MainButton';

export const Main = styled.main`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0;
    @media(min-width: 1280px)
    {
        margin: 0 auto;
    }
    .button-spinner
    {
        float: left;
        margin-right: 10px;
    }
    & .restarted-ms-Grid > .ms-Grid-row
    {
        min-height: 80px !important;
        margin: 0 0 !important;
        & > .ms-Grid-col
        {
            padding-left: 24px;
        }
    }
    & .ms-Stack .ms-StackItem
    {
        width: 100%;
    }
    & .ms-Stack .ms-StackItem,
    & .investment-fund-finder .ms-ComboBox-container
    {
        margin-top: 24px;
    }
    & .ms-Stack .ms-StackItem:first-child,
    .investment-fund-finder .ms-ComboBox-container:first-child
    {
        margin-top: 0;
    }
    & .ms-Stack .ms-StackItem:not(:first-child)
    {
        margin-left: 0;
    }
    & .ms-ChoiceField
    {
        display: inline-flex;
        margin-right: 8px;
        background: ${props => props?.theme?.palette?.white || "#FFF"};
        border: 1px solid ${props => props?.theme?.palette?.neutralLighter || "#E9EFF1"};
        padding: 10px 16px;
        border-radius: 26px;
    }
`;
export const SeparatorTop = styled(Separator)`
    margin-bottom: 1em;
`;
export const SeparatorForm = styled(Separator)`
    margin-top: 0;
    margin-bottom: 17px;
`;
export const OuterFooterArea = styled.div`
    display: flex;
    justify-content: flex-end;
`;
export const Text = styled.p`
    font-size: 18px;
    line-height: 24px;
    color: ${props => props?.theme?.palette?.lightBlack || "#556769"};
    margin-top: 0;
    margin-bottom: 0;
`;
export const TextSmall = styled.p`
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    margin: 0;
    margin-top: 32px;
    color: ${props => props?.theme?.palette?.neutralText || "#95A0A1"};
`;
export const TextInfoOutdated = styled.p`
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
    margin: 0;
    cursor: default;
    margin-top: 32px;
    color: ${props => props?.theme?.palette?.neutralText || "#95A0A1"};
`;
export const TextInfoOutdatedInCard = styled(TextInfoOutdated)`
    margin-top: 0;
`;
export const TitleRow = styled.div`
    min-height: 20px;
`;
export const SubTitleCol = styled.div`
    padding-top: 12px;
    color: #CC214F;
`;
export const OuterFooterAreaStart = styled(OuterFooterArea)`
    justify-content: flex-start;
    margin-top: 1rem;
`;
export const OuterFooterAreaStartNoMargin = styled(OuterFooterArea)`
    justify-content: flex-start;
`;
export const StackItemWithMargin = styled.div`
    margin-top: 1em;
`;
export const LinkNoDecoration = styled(Link)`
    text-decoration: none;
`;
export const AmountTypeHeading = styled.h3`
    margin-bottom: 15px !important;
`;
export const AmountInputWrapper = styled.div`
    .amountText input
    {
        text-align: end;
    }
`;
export const BackButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
    span
    {
        margin-right: 10px;
        cursor: pointer;
    }
`;
export const TitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    cursor: default;
    h2
    {
        margin: 0;
        cursor: default;
    }
`;
export const SubTitleContainer = styled.h3`
    margin: 0;
    cursor: default;
`;
export const CardContainer = styled.div`
    background-color: ${props => props?.theme?.palette?.tertiary || "#F3F7F9"};
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    margin-bottom: 20px;
    padding: 20px 40px 20px 40px;
`;
export const OutdatedCardContainer = styled.div<{ theme?: any }>`
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    background: ${(props) => props?.theme?.palette?.warnSecondary ?? '#FFF1BE'};
    color: ${(props) => props?.theme?.palette?.warn ?? '#F69A2D'};
    padding: 24px;
    margin-bottom: 20px;
    gap: 16px;
    font-weight: 500;
`;
export const OutdatedCardContent = styled.div`
    display: flex;
    align-items: flex-end;
    gap: 16px;
    flex-wrap: wrap;
    p
    {
        line-height: 20px;
        margin: 0;
        color: inherit;
    }
`;
export const OutdatedCardText = styled.div`
    flex: 1;
    min-width: 0;
`;
export const OutdatedCardButton = styled(Button.Primary)`
    flex-shrink: 0;
    margin: 0;
    padding: 0.5rem 1rem;
    font-size: 14px;
`;
export const CardHeader = styled.div`
    display: flex;
    flex-direction: column;
    flex: 0 1 0;
    justify-content: center;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    h3
    {
        margin: 0;
        font-size: 20px;
        line-height: 28px;
        font-weight: 600;
    }
    .small-text
    {
        margin-top: 6px;
    }
`;
export const CardButton = styled(Button.Primary)`
    margin-top: 32px;
    margin-bottom: 0px;
`;
export const CardButtonBack = styled(CardButton)`
    margin-right: auto;
`;
export const CardButtonSimulate = styled(CardButton)`
    margin-right: 1em;
`;
export const CardButtonSubmit = styled(CardButton)`
    float: right;
`;
export const CardHeadingContainer = styled.div`
    margin-top: 10px;
    cursor: default;

    h3
    {
        cursor: default;
    }
`;
export const CardBody = styled.div`
    margin-top: 19px;
`;
export const OutdatedCardBody = styled(CardBody)`
    margin-top: 8px;
`;
export const SectionContainer = styled.div`
    padding: 0;
    margin-top: 2em;
`;
export const WarningContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    cursor: default;
    border-radius: 16px;
    background: #FFF1BE;
    color: #F69A2D;
    padding: 30px;
    gap: 12px;
    font-weight: 500;
    & > div:first-of-type
    {
        flex-shrink: 0;
    }
    img
    {
        display: block;
    }
    p
    {
        line-height: 20px;
        margin: 0;
    }
`;

export const AmountDisclaimerWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    cursor: default;
    border-radius: 16px;
    background: #FFF1BE;
    color: #F69A2D;
    padding: 16px 20px;
    gap: 12px;
    font-weight: 500;
    margin: 10px 0 0;
    p
    {
        line-height: 20px;
        margin: 0;
    }
`;

export const AutoSwitchWarningWrapper = styled.div`
    margin: 10px 0 0;
`;